import { CommonClassNameAndTestId } from "@typings/Common";
import { cn } from "@util/helpers";

export type SpinnerProps = {
  /** Additional class names for outer border styling */
  outerClassName?: string;
  /** Additional class names for inner border styling */
  innerClassName?: string;
} & CommonClassNameAndTestId;

export default function Spinner({
  outerClassName,
  innerClassName,
  className,
}: SpinnerProps): React.ReactElement {
  return (
    <div
      data-testid="spinner-component"
      className={cn(
        "flex flex-grow items-center justify-center py-8",
        className
      )}
    >
      <div
        className={cn(
          "from-slate-800 flex h-12 w-12 animate-spin items-center justify-center rounded-full bg-gradient-to-tr from-gray-850 to-gray-400",
          outerClassName
        )}
      >
        <div
          className={cn("h-8 w-8 rounded-full bg-white", innerClassName)}
        ></div>
      </div>
    </div>
  );
}
